import {lazy} from '@aboutyou/lazy-imports';

export const SizeAdvisorWidget = lazy(() =>
  import('./SizeAdvisorWidget').then(mod => ({default: mod.SizeAdvisorWidget})),
);
